import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { NgIf } from '@angular/common';

import { RemoveCircleIconButtonComponent } from '../remove-circle-icon-button';

@Component({
  selector: 'wo-remove-control-button',
  templateUrl: './remove-control-button.component.html',
  styleUrls: [ './remove-control-button.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    RemoveCircleIconButtonComponent,
  ],
})
export class RemoveControlButtonComponent {
  @Input() public inactive?: boolean | null;
  @Input() public tooltip?: string;
  @Input() public size: 'large' | 'small' = 'large';
  @Output() public readonly remove = new EventEmitter<void>();
}
